import ImageTextCarouselGrid from "hec/components/image-text-carousel-grid";
import { ProductCategoryCarousel } from "hec/components/product-category-carousel";

import { cn } from "~/lib/utils";

import type { HomepageCarouselGridProps } from "./types";

const HomepageCarouselGrid: React.FC<HomepageCarouselGridProps> = props => {
  const {
    addedToCartPodId = "",
    slidesVisible,
    resultCount = 10,
    productTileBorderColor,
    showPeek,
    slidePadding,
    productCategory,
    ButtonNavigationColor,
    showNavigationArrows,
    iconsHeaderText = "Popular Categories",
    productCarouselHeaderText = "",
    enableHeroOverlap = false,
    items = [],
    carouselCtaText,
    enableBasicView,
    external,
    external_link,
    link,
    attributes,
  } = props;

  const categoryId = productCategory?.options?.category ?? "";

  const ctaHref = external
    ? (external_link?.value?.data?.url ?? "#")
    : (link?.value?.data?.url ?? "#");

  return (
    <div
      {...(attributes as React.HTMLAttributes<HTMLDivElement>)}
      className={cn(
        "mx-auto flex w-[calc(100%-16px)] max-w-[1440px] flex-col-reverse items-center justify-center gap-5 p-0 lg:flex-row",
        { "z-[9] -mt-[60px]": enableHeroOverlap },
        (attributes as Record<string, string>)?.className,
      )}
    >
      {/* Left panel: Product carousel */}
      <div
        className={cn(
          "left-container flex min-h-[450px] w-full flex-col items-center justify-center rounded-[12px] bg-white shadow-[0_4px_20px_0_rgba(0,0,0,0.22)] lg:w-[68%]",
          !enableBasicView ? "lg:h-auto xl:h-auto" : "lg:h-auto xl:h-auto",
        )}
      >
        <ProductCategoryCarousel
          categoryId={categoryId}
          resultCount={resultCount}
          enableHeadline={!!productCarouselHeaderText}
          headlineText={productCarouselHeaderText}
          addedToCartPodId={addedToCartPodId}
          productTileBorderColor={productTileBorderColor}
          // No tablet values: the grid's editor has no tablet fields, so a
          // stored one is old data authors cannot see. Tablet follows mobile.
          showPeek={showPeek?.onDesktop ?? false}
          showPeekMobile={showPeek?.onMobile ?? false}
          slidesVisible={(slidesVisible?.onDesktop || "4") as "4"}
          slidesVisibleMobile={(slidesVisible?.onMobile || "2") as "2"}
          slidePadding={slidePadding?.onDesktop}
          slidePaddingMobile={slidePadding?.onMobile}
          ButtonNavigationColor={ButtonNavigationColor}
          enableNavigationArrows={true}
          showNavigationArrowsMobile={showNavigationArrows?.onMobile ?? true}
          showNavigationArrowsDesktop={showNavigationArrows?.onDesktop ?? false}
          ctaText={carouselCtaText}
          ctaHref={ctaHref}
          ctaExternal={external}
          enableBasicView={enableBasicView}
          className="h-full w-full"
          data-testid="ProductCategoryCarousel"
        />
      </div>

      {/* Right panel: Category icons grid / carousel (shared standalone component) */}
      <ImageTextCarouselGrid
        iconsHeaderText={iconsHeaderText}
        items={items}
        slidesVisible={slidesVisible}
        slidePadding={slidePadding}
        ButtonNavigationColor={ButtonNavigationColor}
        className="lg:h-auto lg:w-[32%] xl:h-auto"
      />
    </div>
  );
};

export default HomepageCarouselGrid;
